/**
 * @export
 * @param {number} step
 * @returns
 */
export function toggleStep(step) {
  return {
    type: "TOGGLE_STEP",
    step
  };
}

/**
 * @export
 * @returns
 */
export function toggleFirstStep() {
  return {
    type: "TOGGLE_FIRST_STEP",
  };
}

/**
 * @export
 * @param {number} document
 * @returns
 */
export function registerDocument(document) {
  return {
    type: "REGISTER_DOCUMENT",
    document
  };
}

/**
 * @export
 * @param {*} customerCode
 * @returns
 */
export function registerCustomerCode(customerCode) {
  return {
    type: "REGISTER_CUSTOMER_CODE",
    customerCode
  };
}

/**
 * @export
 * @param {*} phoneNumber
 * @param {*} contactId
 * @returns
 */
export function registerPhoneNumber(phoneNumber, contactId) {
  return {
    type: "REGISTER_PHONENUMBER",
    phoneNumber,
    contactId
  };
}

/**
 * @export
 * @param {*} password
 * @param {*} confirmPassword
 * @returns
 */
export function registerPassword(password, confirmPassword) {
  return {
    type: "REGISTER_PASSWORD",
    password,
    confirmPassword
  }
}

export function registerValues(object) {
  return {
    type: "REGISTER_VALUES",
    object
  }
}

export function registerLocation(location) {
  return {
    type: "REGISTER_LOCATON",
    location
  }
}

/**
 * @export
 * @returns
 */
export function resetState() {
  return {
    type: "RESET_STATE"
  }
}
